import React, {Component} from 'react'
import {connect} from 'react-redux'
import * as actions from '../../state/actions'
import {bindActionCreators} from 'redux'
import {Alert} from 'react-bootstrap'
import Spinner from './../common/Spinner'
import { browserHistory } from 'react-router'
import moment from 'moment'

class SubscriptionsDetail extends Component {

    constructor(props) {
        super(props)
        let self = this
        self.state = {

        }
    }

    componentWillMount() {
        var self = this
        self.props.actions.subscriptionGetOne(self.props.params.appCodename, self.props.params.subscriptionId)
    }

    goBack() {
        browserHistory.go(-1)
    }

    render() {
        var self = this
        if (!self.props.subscription) {
            return (<Spinner/>)
        } else if (self.props.subscription && !self.props.subscription._id) {
            return (
                <Alert bsStyle='warning'>
                    <strong>No se encontraron productos!</strong>
                </Alert>
            )
        } else {
            let sb = self.props.subscription
            var platform = sb.platform ? sb.platform : '-'
            var productDescription = (sb.product && sb.product.description) ? sb.product.description : '-'
            var productExternalId = (sb.product && sb.product.externalId) ? sb.product.externalId : '-'
            var productName = (sb.product && sb.product.name) ? sb.product.name : '-'
            var dateTime = new Date(sb.createdAt)
            dateTime = moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
            var productAmountTotal = (sb.product && sb.product.amount) ? '$ ' + sb.product.amount : '-'

            return (
                <div>
                    <div className='row'>
                        <div className='col-lg-12' key='infoSubscription'>
                            <h1 className='page-header'>Información de la Subscripcion</h1>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12' key='detail'>
                            <table className='table table-bordered table-hover'>
                                <tbody>
                                    <tr className='active' key='dateTime'>
                                        <td className='col-md-2'>
                                            <b>Fecha</b>
                                        </td>
                                        <td className='col-md-10'>{dateTime}</td>
                                    </tr>
                                    <tr key='platform'>
                                        <td className='col-md-2'>
                                            <b>Plataforma</b>
                                        </td>
                                        <td className='col-md-10'>{platform}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h3>Datos producto</h3>
                            <table className='table table-bordered table-hover'>
                                <tbody>
                                    <tr className='active' key='productExternalId'>
                                        <td className='col-md-2'>
                                            <b>External Id</b>
                                        </td>
                                        <td className='col-md-10'>{productExternalId}</td>
                                    </tr>
                                    <tr key='productName'>
                                        <td className='col-md-2'>
                                            <b>Nombre</b>
                                        </td>
                                        <td className='col-md-10'>{productName}</td>
                                    </tr>
                                    <tr className='active' key='productDescription'>
                                        <td className='col-md-2'>
                                            <b>Descripción</b>
                                        </td>
                                        <td className='col-md-10'>{productDescription}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h3>Datos del pago</h3>
                            <table className='table table-bordered table-hover'>
                                <tbody>
                                    <tr className='active' key='productAmount'>
                                        <td className='col-md-2'>
                                            <b>Monto Total</b>
                                        </td>
                                        <td className='col-md-10'>{productAmountTotal}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        subscription: state.subscription
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(SubscriptionsDetail)



// WEBPACK FOOTER //
// ./components/SubscriptionsDetail/index.js